import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { LabeledInfo } from 'ui-components/components/labeled-info-list/labeled-info';
import ShipmentNumberLink from '../../../../../components/shipment-number-link';

import messages from '../../messages';

const ShipmentIds = ({ data: fulfillments }) => {
  const intl = useIntl();
  return (
    <LabeledInfo
      label={intl.formatMessage(messages.shipmentLabel, {
        count: fulfillments.length,
      })}
    >
      {fulfillments.map(({ fulfillmentId, fulfillmentPlanId }) => (
        <ShipmentNumberLink key={`${fulfillmentPlanId}-${fulfillmentId}`} fulfillmentPlanId={`${fulfillmentPlanId}`} />
      ))}
    </LabeledInfo>
  );
};

ShipmentIds.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      fulfillmentId: PropTypes.string,
      fulfillmentPlanId: PropTypes.number,
    }),
  ).isRequired,
};

export default ShipmentIds;
